import { ListSubheader, TextField } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import React, { useMemo, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { DelayInput } from "react-delay-input/lib/Component";
import { regex } from "../../../utils/consts";

import { EXCHANGE_TYPE } from "../../../utils/consts";

import { Skeleton } from "@material-ui/lab";

import {
  StyledExchangerInput,
  StyledExchangerItem,
  StyledExchangerOptions,
  StyledExchangerSelect
} from "./styledExchanger";

const ExchangerItem = ({
  t,
  type,
  exchangePairUnit,
  exchange,
  setExchange,
  selectedExchangePairUnit,
  setSelectedExchangePairUnit,
  calculate,
  physicalExchangeData
}) => {

  const containsText = (option, searchText) => {
    const text = option.service + " " + option.currency;

    return text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  };

  const [searchText, setSearchText] = useState("");
  const displayedOptions = useMemo(
    () => exchangePairUnit.filter((option) => containsText(option, searchText)),
    [searchText, exchangePairUnit]
  );

  const handleChangeSelect = (e) => {
    let data = e.target.value;

    if (!data) {
      return;
    }

    let newExchange = exchange;

    newExchange[type + "Currency"] = data.currency;
    newExchange[type + "Service"] = data.service;
    newExchange["inAmount"] = 0;
    newExchange["outAmount"] = 0;
    newExchange["isSelect"] = true;
    setExchange(newExchange);

    setSelectedExchangePairUnit(data);

    calculate(0, type);
  };

  const handleChangeInput = (e) => {
    let amount = e.target.value;

    if (["", NaN, undefined, null].includes(amount)) {
      e.target.value = type === EXCHANGE_TYPE.IN ? exchange.inAmount : exchange.outAmount;
      return;
    }

    if (!amount.match(regex.FLOAT_NUMBER)) {
      e.target.value = type === EXCHANGE_TYPE.IN ? exchange.inAmount : exchange.outAmount;
      return;
    }

    if (!amount.match(regex.CALCULATED_AMOUNT)) {
      amount = amount.replace(regex.FLOAT_VALUE_WRITE, regex.ONE_ELEMENT);
      e.target.value = amount;
      return;
    }

    setAmount(amount);
  };

  const setAmount = (data) => {
    setExchange((prevState) => (type === EXCHANGE_TYPE.IN ?
        { ...prevState, inAmount: data } :
        { ...prevState, outAmount: data }
    ));

    calculate(data, type);
  };

  const renderRate = () => {
    if (!exchange.rate || type === EXCHANGE_TYPE.OUT) {
      return null;
    }

    return (
      <StyledExchangerOptions disabled>
        {t("exchanger.currentRate")}: <span>1 {exchange.inCurrency} ≈ {exchange.rate} {exchange.outCurrency} </span>
      </StyledExchangerOptions>
    );
  };

  const renderMinAmount = (type) => {
    let attributeName = type + "MinAmount";

    if (!physicalExchangeData[attributeName]) {
      return;
    }

    return (
      <StyledExchangerOptions>
        {t("exchanger." + attributeName)}: <span
        onClick={() => setAmount(physicalExchangeData[attributeName])}
      >{physicalExchangeData[attributeName]} {exchange[type + "Currency"]} </span>
      </StyledExchangerOptions>
    );
  };

  let currentService = selectedExchangePairUnit ? exchangePairUnit.filter(item => {
    return item.currency === selectedExchangePairUnit.currency && item.service === selectedExchangePairUnit.service;
  })[0] : null;

  return (
    <StyledExchangerItem>
      <div className="title">
        {type === EXCHANGE_TYPE.IN ? t("exchanger.iGive") : t("exchanger.iReceive")}
      </div>
      <StyledExchangerSelect>
        {exchangePairUnit ?
          <FormControl>
            {exchangePairUnit.length ?
              <>
                <InputLabel id={`${type}-service-label`}>
                  {type === EXCHANGE_TYPE.IN ? t("exchanger.giveService") : t("exchanger.receiveService")}
                </InputLabel>
                {/* No need to change on Autocomplete component (exchanger) */}
                <Select
                  labelId={`${type}-service-label`}
                  id={`${type}-service`}
                  value={currentService ?? ""}
                  onChange={(e) => handleChangeSelect(e)}
                  onClose={() => setSearchText("")}
                  className="exchanger-select"
                  MenuProps={{ autoFocus: false }}
                >
                  <ListSubheader>
                    <TextField
                      size="small"
                      autoFocus
                      placeholder={t("exchanger.search.placeholder")}
                      fullWidth
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      onClick={(e) => {e.stopPropagation();}}
                    />
                  </ListSubheader>
                  {displayedOptions.map((item, key) => (
                    <MenuItem
                      key={key}
                      value={item}
                    >
                      <div className="exchanger-select__option">
                        <span>{item.service} {item.currency}</span> <span className="balance">{item.amount}</span>
                      </div>
                    </MenuItem>
                  ))}
                </Select>
              </>
              :
              <Alert className="exchanger-alert" severity="warning">
                {t("exchanger.noPairs")}
              </Alert>
            }
          </FormControl> :
          <Skeleton
            variant="rect"
            height={30}
          />
        }
      </StyledExchangerSelect>
      <StyledExchangerInput>
        <label htmlFor={`${type}-amount`}>
          {type === EXCHANGE_TYPE.IN ? t("exchanger.iGive") : t("exchanger.iReceive")}
        </label>
        <DelayInput
          id={`${type}-amount`}
          delayTimeout={800}
          onChange={handleChangeInput}
          name={`${type}-amount`}
          value={type === EXCHANGE_TYPE.IN ? exchange.inAmount : exchange.outAmount}
          type="text"
          placeholder="1000"
        />
      </StyledExchangerInput>
      <div>
        {selectedExchangePairUnit && type === EXCHANGE_TYPE.IN &&
          <StyledExchangerOptions>
            {t("exchanger.availableBalance")}: <span
            onClick={() => setAmount(selectedExchangePairUnit.amount)}
          >{selectedExchangePairUnit.amount} {selectedExchangePairUnit.currency}</span>
          </StyledExchangerOptions>}
        {/*{selectedExchangePairUnit && type === EXCHANGE_TYPE.OUT &&*/}
        {/*  <StyledExchangerOptions>*/}
        {/*    {t("exchanger.reserve")}: <span*/}
        {/*    onClick={() => setAmount(selectedExchangePairUnit.reserve)}*/}
        {/*  >{selectedExchangePairUnit.reserve} {selectedExchangePairUnit.currency}</span>*/}
        {/*  </StyledExchangerOptions>}*/}
        {renderRate()}
        {renderMinAmount(type)}
      </div>
    </StyledExchangerItem>
  );
};

export default ExchangerItem;